export default "__VITE_ASSET__2Bk6WOcx__"